import React, { useEffect, useState } from 'react';
import { BiLinkExternal } from 'react-icons/bi';
import { BsChevronDown } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import {
  AnnotationFromResponse,
  LessonWithAnnotations,
} from '../../../../services/course/annotations';
import AnnotationCard from '../AnnotationCard';
import {
  LessonCardAnnotations,
  LessonCardContainer,
  LessonCardContent,
  LessonCardContentsDivider,
  LessonCardLinkContainer,
  LessonCardLowerContent,
  LessonCardTitle,
  LessonCardToogleButton,
  LessonCardUpperContent,
} from './style';

interface LessonCardProdps {
  lesson: LessonWithAnnotations;
  courseId: string;
}

const LessonCard: React.FC<LessonCardProdps> = ({ lesson, courseId }) => {
  const [annotations, setAnnotations] = useState<AnnotationFromResponse[]>([]);
  const [shouldShowAnnotations, setShouldShowAnnotations] = useState(false);

  const removeAnnotation = (annotationId: string) => {
    const annotationToBeRemoved = lesson.annotations.find(
      annotation => annotation.annotation_id === annotationId,
    );

    if (annotationToBeRemoved) {
      const annotationToBeRemovedIndex = lesson.annotations.indexOf(
        annotationToBeRemoved,
      );

      lesson.annotations.splice(annotationToBeRemovedIndex, 1);
      setAnnotations([...lesson.annotations]);
    }
  };

  const toogleAnnotations = () => {
    setShouldShowAnnotations(!shouldShowAnnotations);
  };

  useEffect(() => {
    setAnnotations([...lesson.annotations]);
  }, [lesson.annotations]);

  return (
    <LessonCardContainer>
      <LessonCardUpperContent>
        <LessonCardToogleButton
          className={`${shouldShowAnnotations ? 'up' : 'down'}`}
          onClick={toogleAnnotations}
        >
          <BsChevronDown />
        </LessonCardToogleButton>
        <LessonCardContent>
          <LessonCardTitle>{lesson.title}</LessonCardTitle>
          <LessonCardLinkContainer>
            <Link to={`/courses/${courseId}/lessons/${lesson.content_id}`}>
              <span>Ir pra aula</span>
              <BiLinkExternal />
            </Link>
          </LessonCardLinkContainer>
        </LessonCardContent>
      </LessonCardUpperContent>

      {shouldShowAnnotations && (
        <>
          <LessonCardContentsDivider />

          <LessonCardLowerContent>
            <LessonCardAnnotations>
              {annotations && annotations.length ? (
                annotations.map(annotation => (
                  <AnnotationCard
                    key={annotation.annotation_id}
                    onDeleteAnnotation={removeAnnotation}
                    annotation={annotation}
                  />
                ))
              ) : (
                <></>
              )}
            </LessonCardAnnotations>
          </LessonCardLowerContent>
        </>
      )}
    </LessonCardContainer>
  );
};

export default LessonCard;
